// Models
/** Extension fields for the copilot */ export class CopilotExtensions {
    constructor(loopPageUrl){
        this.loopPageUrl = loopPageUrl;
    }
}
